module.exports = __webpack_public_path__ + "media/Outdoor Square Dance.31224454.mp4";